// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"82085aa7","641":"70c2c824","756":"5fdcf82d","858":"9e0bf7aa","924":"f854e8c5","930":"6ce270c3"}[chunkId] + ".chunk.js";
};